<template>
    <section class="layout-alianzas">
        <div class="container max-width-lg">
            <div class="row max-width-md section-title">
                <div class="col-12">
                    <h1>
                        Alianzas Estratégicas
                    </h1>
                </div>
            </div>

            <div class="row layout--carousel">
                <a href="http://www.neonnieto.com/" class="col layout--card" target="_blank">
                    <img src="../../../assets/images/logo-neon-nieto-new.jpg" alt="Logo Neon Nieto" />
                </a>

                <a href="https://www.creelighting.com/" class="col layout--card" target="_blank">
                    <img src="../../../assets/images/logo_cree.png" alt="Logo Cree" />
                </a>

                <a href="https://www.hubbell.com/hubbelllightingci/en/" class="col layout--card" target="_blank">
                    <img src="../../../assets/images/logo_hubbell.png" alt="Logo Hubbell" />
                </a>

                <a href="https://greencreative.com/" class="col layout--card" target="_blank">
                    <img src="../../../assets/images/logo_green_creative.png" alt="Logo Green Creative" />
                </a>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "SectionAlianzas"
    }
</script>
<style lang="scss" scoped>
.layout-alianzas {

    @media (max-width: 1360px) {
        padding: 60px 0px 0px;
    }

    .layout--carousel {
        margin: 0 0 6rem;

        .layout--card {

            @media (max-width: 1360px) {
                margin:10px 15px;
            }
        }
    }
}
</style>